/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_Map_TitleInputs */

const en_pwf_map_title = /** @type {(inputs: Pwf_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where do the items go?`)
};

const de_pwf_map_title = /** @type {(inputs: Pwf_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wohin wandern die Vorgänge?`)
};

/**
* | output |
* | --- |
* | "Where do the items go?" |
*
* @param {Pwf_Map_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_map_title = /** @type {((inputs?: Pwf_Map_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Map_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_map_title(inputs)
	return en_pwf_map_title(inputs)
});